export default __webpack_public_path__ + "static/media/close_dark.e8ee5b49.svg";